import React, { useEffect, useState } from 'react';
import { LayoutChangeEvent, StyleSheet, View } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import Animated, { Easing, useAnimatedStyle, useSharedValue, withRepeat, withTiming } from 'react-native-reanimated';
import { CHAT_SKELETON } from '../../constants';
import type { TChatSkeletonBarProps } from '../../types';

export const ChatSkeletonBar = ({ className = '', style: extraStyle, tint = false }: TChatSkeletonBarProps) => {
    const { base, band } = CHAT_SKELETON.colors[tint ? 'tint' : 'neutral'];
    const [width, setWidth] = useState(0);
    const progress = useSharedValue(0);

    useEffect(() => {
        progress.value = withRepeat(
            withTiming(1, { duration: CHAT_SKELETON.sweepMs, easing: Easing.linear }),
            -1,
            false,
        );
    }, [progress]);

    const sweepStyle = useAnimatedStyle(() => ({
        transform: [{ translateX: -width + 2 * width * progress.value }],
    }));

    return (
        <View
            className={`overflow-hidden rounded ${className}`}
            style={[{ backgroundColor: base }, extraStyle]}
            onLayout={(event: LayoutChangeEvent) => setWidth(event.nativeEvent.layout.width)}
        >
            {width > 0 && (
                <Animated.View style={[styles.sweep, { width: width * 2 }, sweepStyle]}>
                    <LinearGradient
                        colors={[base, band, base, base]}
                        locations={[0, 0.2, 0.4, 1]}
                        start={{ x: 0, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        style={styles.fill}
                    />
                </Animated.View>
            )}
        </View>
    );
};

const styles = StyleSheet.create({
    sweep: { height: '100%' },
    fill: { flex: 1 },
});
